import { Button, Card, Input, Label } from "@repo/ui";
import { SignedIn, StardeckSignInButton, useAuth } from "@stardeck-customer-apps/project-auth";
import { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function LoginPage() {
  const nav = useNavigate();
  const loc = useLocation();
  const { isAuthenticated } = useAuth();

  // If already signed in, redirect to returnTo or /admin
  useEffect(() => {
    if (isAuthenticated) {
      const sp = new URLSearchParams(loc.search);
      const returnTo = sp.get("returnTo") || "/admin";
      nav(returnTo, { replace: true });
    }
  }, [isAuthenticated, loc.search, nav]);

  return (
    <div className="mx-auto max-w-md py-16">
      <Card className="p-6 bg-card/70 border-border/60">
        <div className="mb-4 flex items-center gap-2">
          <div className="size-8 rounded-md bg-gradient-to-br from-indigo-400 to-violet-500 grid place-items-center text-[10px] font-bold text-black/80">
            LN
          </div>
          <div className="font-display text-lg">เข้าสู่ระบบ — Lucky News</div>
        </div>
        <p className="text-sm text-foreground/70 mb-4">เข้าสู่ระบบเพื่อจัดการหลังบ้าน</p>
        <div className="grid gap-3 mb-4">
          <div className="grid gap-1">
            <Label htmlFor="username">อีเมลหรือยูสเซอร์เนม</Label>
            <Input id="username" placeholder="you@example.com" />
          </div>
          <div className="grid gap-1">
            <Label htmlFor="password">รหัสผ่าน</Label>
            <Input id="password" type="password" placeholder="••••••••" />
          </div>
        </div>
        <StardeckSignInButton className="w-full" size="medium">
          Sign in with Stardeck
        </StardeckSignInButton>
        <p className="text-xs text-foreground/60 mt-2">
          ปุ่มนี้จะพาไปหน้า SSO ของ Stardeck แล้วกลับมาหลังบ้านอัตโนมัติ
        </p>
        <div className="mt-4 flex justify-between text-xs text-foreground/60">
          <Link to="/">กลับหน้าแรก</Link>
          <Link to="/contact">ติดต่อเรา</Link>
        </div>
        <SignedIn>
          <Button className="mt-4 w-full" asChild>
            <Link to="/admin">ไปหลังบ้าน</Link>
          </Button>
        </SignedIn>
      </Card>
    </div>
  );
}
